import { CloudOff } from "lucide-react";
import { Navigate, Outlet, useLocation } from "react-router";

import { useSession } from "@/app/session/useSession";
import { useT } from "@/shared/i18n/useT";
import { LogoMark } from "@/shared/ui/brand/LogoMark";
import { Button } from "@/shared/ui/Button";
import { EmptyState } from "@/shared/ui/EmptyState";

export function FullScreenLoader() {
  return (
    <div className="grid min-h-dvh place-items-center bg-canvas" aria-busy="true">
      <LogoMark size={40} className="motion-safe:animate-pulse" />
    </div>
  );
}

function SessionUnavailable({ onRetry }: { onRetry: () => void }) {
  const t = useT();
  return (
    <div className="grid min-h-dvh place-items-center bg-canvas px-6">
      <EmptyState
        icon={CloudOff}
        tone="danger"
        title={t("errors.network")}
        body={t("errors.unavailable.body")}
        action={<Button onClick={onRetry}>{t("common.retry")}</Button>}
      />
    </div>
  );
}

/** Everything behind sign-in: wait for the session, else send the person to sign in. */
export function RequireSession() {
  const { state, retry } = useSession();
  const location = useLocation();

  if (state.status === "loading") return <FullScreenLoader />;
  if (state.status === "unavailable") return <SessionUnavailable onRetry={retry} />;
  if (state.status === "signed-out") {
    const next = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/sign-in?next=${next}`} replace />;
  }
  return <Outlet />;
}
